"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M8.4 8.1a.9.9 0 10-1.8 0 .9.9 0 001.8 0zM17.4 8.1a.9.9 0 00-.9-.9h-6a.9.9 0 100 1.8h6a.9.9 0 00.9-.9zM6.6 12a.9.9 0 111.8 0 .9.9 0 01-1.8 0zM17.4 12a.9.9 0 00-.9-.9h-6a.9.9 0 000 1.8h6a.9.9 0 00.9-.9zM6.6 15.9a.9.9 0 011.8 0 .9.9 0 11-1.8 0zM17.4 15.9a.9.9 0 00-.9-.9h-6a.9.9 0 100 1.8h6a.9.9 0 00.9-.9z" }), "List");
//# sourceMappingURL=List.js.map